import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled, { css } from 'styled-components';
import { minBreakpointQuery, sectionMargins, standardColours } from '../styles';
import { Container } from './ui';

const StyledContainedImage = styled.section`
  ${({ isBlogSingle }) =>
    isBlogSingle ? sectionMargins('30px', '50px') : sectionMargins()}
`;

const StyledImageWrapper = styled.div`
  ${({ isBlogSingleFeatured }) => {
    if (isBlogSingleFeatured) {
      return css`
        padding-top: 20px;
        border-top: 1px solid ${standardColours.lighterGrey};

        ${minBreakpointQuery.small`
          padding-top: 30px;
        `}

        ${minBreakpointQuery.large`
          padding-top: 40px;
        `}
      `;
    }
  }}
`;

const ContainedImage = ({
  image: { gatsbyImageData, alt },
  isBlogSingle,
  isBlogSingleFeatured,
}) => (
  <StyledContainedImage isBlogSingle={isBlogSingle}>
    <Container narrow={isBlogSingle}>
      <StyledImageWrapper isBlogSingleFeatured={isBlogSingleFeatured}>
        <GatsbyImage image={gatsbyImageData} alt={alt} />
      </StyledImageWrapper>
    </Container>
  </StyledContainedImage>
);

export default ContainedImage;
